import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formValueSelector } from 'redux-form';

import { LOG_IN_FORM } from '../../constants';

import {
    clearAuthNotification as clearAuthNotificationAction,
    redirectToLogIn as redirectToLogInAction,
    trackSocialProviderCreateAccount as trackSocialProviderClickAction,
    signUpUser as signUpUserAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    cleanSocialAuthenticationData as cleanSocialAuthenticationDataAction,
    resetForm as resetFormAction,
} from '../../actions/auth';

import {
    cancelToS as cancelToSAction,
    acceptToS as acceptToSAction,
    acceptSocialToS as acceptSocialToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import {
    lookupUser as lookupUserAction,
    setSignupSecondStep as setSignupSecondStepAction,
} from '../../actions/lookup';

import { sendSoftAccountEmail as sendSoftAccountEmailAction } from '../../actions/softAccount';

import SignupPage from './SignupPage';

const _mapStateToProps = (state) => ({
    form: state.form,
    email: state.authentication.email,
    locale: state.authentication.locale,
    recaptcha2PublicKey: state.authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: state.authentication.recaptcha3PublicKey,
    showCaptcha: state.authentication.displayCaptcha,
    fp: state.authentication.fp,
    socialSSOSettings: state.authentication.socialSSOSettings,
    authNotificationOptions: state.authentication.authNotificationOptions,
    disableRecaptcha3: state.authentication.disableRecaptcha3,
    usesNewStyles:
        state.authentication.featureFlags.launchAuthenticationRefactor,
    signUpSecondStep: state.status.signUpSecondStep,
    previousFormEmail: formValueSelector(LOG_IN_FORM)(state, 'email'),
    isSoftAccount: state.frontend.showModal,
});

const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onLoginInsteadClick: redirectToLogInAction,
    onSignupLookup: lookupUserAction,
    onSignUpUser: signUpUserAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    setSignupSecondStep: setSignupSecondStepAction,
    cancelToS: cancelToSAction,
    acceptToS: acceptToSAction,
    acceptSocialToS: acceptSocialToSAction,
    showToS: showToSAction,
    cleanSocialAuthenticationData: cleanSocialAuthenticationDataAction,
    handleSoftAccount: sendSoftAccountEmailAction,
    resetForm: resetFormAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
